import React, { useEffect, useState } from 'react';
import { Card, CardTitle, CardBody, Button, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';

const HostelList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [hostelList, setHostelList] = useState([]);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const onHandleAdd = () => {
    navigate('/save-hostel');
  };

  const onHandleEdit = (id) => {
    const selected = hostelList.find((x) => x.id === id);
    navigate('/save-hostel', { state: { ...(selected || {}) } });
  };

  const onHandleDelete = async (id) => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      if (!id) return;
      if (!window.confirm('Are you sure you want to delete this hostel?'))
        return;

      // ✅ API name: DeleteHostel
      const res = await apiService.delete(
        `api/HostelMaster/DeleteHostel?id=${id}&vendorId=${vendorId}&branchId=${branchId}`,
      );

      if (res?.status === true) {
        alert(res?.message || 'Deleted');
        GetHostelList();
      } else {
        alert(res?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      alert('Something went wrong');
    }
  };

  const GetHostelList = async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const res = await apiService.get(
        `api/HostelMaster/GetAllHostel?vendorId=${vendorId}&branchId=${branchId}`,
      );

      if (res?.status === true) {
        setHostelList(res.data || []);
      } else {
        alert(res?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      alert('Something went wrong');
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      GetHostelList();
    } else {
      setHostelList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionData.vendor_id, selectionData.branch_id]);

  return (
    <>
      <div className='text-right mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Hostel
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>
          <i className='bi bi-building mr-2' /> Hostel Master
        </CardTitle>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th style={{ width: 120 }}>Action</th>
                <th>Hostel Name</th>
                <th>Fee Type</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {hostelList.length > 0 ? (
                hostelList.map((x, i) => (
                  <tr key={x.id}>
                    <td>{i + 1}</td>

                    <td>
                      <i
                        className='bi bi-pencil-square text-primary me-3'
                        style={{ cursor: 'pointer' }}
                        title='Edit'
                        onClick={() => onHandleEdit(x.id)}
                      />
                      <i
                        className='bi bi-trash text-danger'
                        style={{ cursor: 'pointer' }}
                        title='Delete'
                        onClick={() => onHandleDelete(x.id)}
                      />
                    </td>

                    <td>{x.hostel_name}</td>
                    <td>{x.fee_type}</td>
                    <td>{x.amount}</td>
                    <td>
                      {x.is_active ? (
                        <span className='text-success'>Active</span>
                      ) : (
                        <span className='text-danger'>Inactive</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='6' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default HostelList;
